/**
 * @Author: alexandre
 * @Date:   2018-03-07T11:33:46-05:00
 * @Email:  alexandre@atomicmotion.com
 * @Filename: index.js
 * @Last modified by:   alexandre
 * @Last modified time: 2018-09-04T11:20:16-04:00
 * @Copyright: Atomic Motion
 */



import React, {
  Component
} from 'react';
import axios from 'axios';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom'
import { HashRouter } from 'react-router-dom'


import './css/react-table.css';
import './css/App.css';

import App from './App';
import Details from './details';
import registerServiceWorker from './registerServiceWorker';
import ReactCSSTransitionReplace from 'react-css-transition-replace';

import { Element, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'


class RouterDom extends Component {

  constructor(props) {
    super(props);

    this.state = {
      ncpldata: [],
      ncpldataRaw: [],
      lang: typeof window.cdanet_lang !== 'undefined' ? window.cdanet_lang : 'en',
      scrollPos: 200,
    };
  }

  setScrollPos = (pos) => {
    this.setState({scrollPos: pos});
  }

  componentWillMount = () => {
    axios.get(typeof window.cdanet_api !== 'undefined' ? window.cdanet_api : 'https://n-cpl.cda-adc.ca/api', {}).then(values => {
      this.setState({
        ncpldata: values.data.data.carriers.sort((a, b) => a.name.en.localeCompare(b.name.en)),
      })
    })
  }

  render() {
    return (
      <HashRouter >
        <div>

          <Route render={({ location }) => (
            // <ReactCSSTransitionReplace
            //   transitionName="fade-wait"
            //   transitionEnterTimeout={600}
            //   transitionLeaveTimeout={0}
            // >
              <div key={location.pathname}>
                <Switch location={location}>
                  <Route path="/" render={(props) => <App {...props} lang={this.state.lang} ncpldata={this.state.ncpldata} scrollPos={this.state.scrollPos} setScrollPos={this.setScrollPos.bind(this)} />} exact ignoreScrollBehavior={true}/>
                  <Route path="/bin/:carrierId" render={(props) => <Details {...props} ncpldata={this.state.ncpldata} lang={this.state.lang} />} ignoreScrollBehavior={true} />
                </Switch>
              </div>
            // </ReactCSSTransitionReplace>
          )} />

        </div>
      </HashRouter>
    );
  }
}


ReactDOM.render(document.getElementById('root') ? <RouterDom/> : <RouterDom/>, document.getElementById('root') ? document.getElementById('root') : document.getElementsByTagName('body'));
registerServiceWorker();